// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible'
import Axios from 'axios'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios

// TODO 打包前记得改
export const BaseUrl = 'https://api-test.tadachat.live/faceshow'; // 测试
// export const BaseUrl = 'https://api.tadachat.info/faceshow'; // 正式
Axios.defaults.baseURL = BaseUrl;

import VueI18n from 'vue-i18n'
import { getLanguage } from "./tools/utils";

/**
 * 全局rem适配
 * 根据每个页面的textSize方法挪过来的,之前是每个页面都调用一次，
 * 每个页面调用会导致页面加载后突然变宽，所以这里全局调用一次
 * 且引入了lib-flexible/flexible，不理解，但是已经安全使用了5年，
 * 后面如果有需要可以优化
 * */
(function (a) {
  function b() {
    var width = g.getBoundingClientRect().width;

    a.rem = width / 7.5 > 100
      ? 100
      : width / 7.5 < 300 / 7.5
      ? 300 / 7.5
      : width / 7.5;

    g.style.fontSize = a.rem + 'px';
  }

  var g = a.document.documentElement;
  var timer;

  a.addEventListener(
    'resize',
    function () {
      clearTimeout(timer);
      timer = setTimeout(b, 300);
    },
    false
  );

  a.addEventListener(
    'pageshow',
    function (e) {
      if (e.persisted) {
        clearTimeout(timer);
        timer = setTimeout(b, 300);
      }
    },
    false
  );

  b();
})(window);
// 全局rem适配结束

Vue.use(VueI18n) // 通过插件的形式挂载


const jsSrc = getLanguage();
/*
let jsSrc = navigator.language || navigator.browserLanguage;
*/

let lang = jsSrc.substr(0,2);
if(jsSrc == 'zh-MO' || jsSrc == 'zh-TW' || jsSrc == 'zh-HK' || jsSrc == 'zh-rHK' || jsSrc.indexOf("zh_HANT") != -1) {
	lang = 'zh_HK';

}
if(jsSrc == 'zh-CN' || jsSrc == 'zh-CH' || jsSrc == 'zh-AE') {
	lang = 'zh';
}




const i18n = new VueI18n({
  locale: lang||'en',
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh': require('./lang/zh'),
    'en': require('./lang/en'),
    'ar': require('./lang/ar'),
    'de': require('./lang/de'),
    'es': require('./lang/es'),
    'fr': require('./lang/fr'),
    'hi': require('./lang/hi'),
    'id': require('./lang/id'),
    'it': require('./lang/it'),
    'ja': require('./lang/ja'),
    'ko': require('./lang/ko'),
    'pt': require('./lang/pt'),
    'ru': require('./lang/ru'),
    'th': require('./lang/th'),
    'tr': require('./lang/tr'),
    'vi': require('./lang/vi'),
    'zh_HK': require('./lang/zh_HK')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js